import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Box, Card, Stack, Typography } from "@mui/material";
import { RadioCardProps } from "../lib/type";
import { WebShopIcon } from "@/src/components/WebShopIcon";
import { HintArea } from "../../HintArea";
import { useHintCardStore } from "@/src/stores/useHintCardStore";
import { useShallow } from "zustand/react/shallow";
import { useFieldDetailInfoModal } from "@/src/stores/useFieldDetailInfoModal";

export const RadioCard = ({
  icon,
  label,
  value,
  selected,
  error,
  className,
  onClick,
  id,
  globalHint,
  ...rest
}: RadioCardProps) => {
  const componentMobileHint = rest.hint?.hintsList?.at(0);
  const { hints } = useHintCardStore();
  const mobileHint = hints[0];
  const openHintDetailsModal = useFieldDetailInfoModal(
    useShallow((state) => state.open),
  );

  const isHintShown =
    !globalHint &&
    selected &&
    !!mobileHint &&
    !!componentMobileHint &&
    componentMobileHint.contentDescription === mobileHint.contentDescription;

    return (
    <>
      <Card
        component={"button"}
        type={"button"}
        className={cn(
          "w-full rounded-md border border-solid border-light-gray bg-white px-2 py-3 shadow-none transition-shadow hover:shadow-md max-sm:px-3",
          { "border-blue bg-super-light-blue transition-colors": selected },
          { "border-red": error },
          className,
        )}
        aria-describedby={"radio-button"}
        tabIndex={0}
        onClick={(e) => onClick?.(e, { value, label, icon })}
        {...rest}
      >
        <Stack
          className={cn("flex flex-col items-center gap-2", {
            "max-sm:flex-row max-sm:items-center": !globalHint,
          })}
        >
          {icon && (
            <Box>
              <WebShopIcon
                width={40}
                height={40}
                name={icon}
                fill={"#009DDE"}
              />
            </Box>
          )}
          <Typography
            variant={"body1"}
            className={cn(
              "max-w-60 text-center text-darker-blue max-sm:text-start",
              {
                "text-blue": selected,
              },
            )}
          >
            {label}
          </Typography>
        </Stack>
      </Card>
      {isHintShown && (
        <HintArea
          className={"hidden transition-opacity max-md:flex"}
          hintAreaDetailsButtonText={mobileHint.hintCardDetailsButtonText}
          hintAreaDetailsButton={mobileHint.hintCardDetailsButton}
          onHintAreaDetailsButtonPressed={() =>
            openHintDetailsModal({
              title: mobileHint.hintDetailsTitle || "",
              actions: mobileHint.hintDetailsActions,
              description: mobileHint.hintDetailsDescription || "",
            })
          }
        >
          {mobileHint.contentDescription}
        </HintArea>
      )}
    </>
  );
};
